module.exports = __webpack_public_path__ + "img/gift_50.3f49d027.webp";